

export default function Footer() {

    return (
        <>
            <footer className="bg-dark py-4 mt-auto footer--pin">
                <div className="container px-5">
                    <div className="row align-items-center justify-content-between flex-column flex-sm-row">
                        <div className="col-auto">
                            <div className="small m-0 text-white">Copyright &copy; TrainLookout 2024</div>
                        </div>
                        <div className="col-auto">
                            <a className="fs-5 px-2 text-white" href="https://twitter.com/trainlookout" target="_blank"><i className="bi-twitter" /></a>
                            <a className="fs-5 px-2 text-white" rel="me" href="https://mastodon.world/@trainlookout" target="_blank"><i className="bi-mastodon" /></a>
                            <a className="fs-5 px-2 text-white" rel="me" href="https://bsky.app/profile/trainlookout.bsky.social" target="_blank"><i className="bi-moon-fill" /></a> {/* Temp icon */}
                            
                            <span className="text-white mx-1">&middot;</span>
                            <a className="link-light small" href="/blog">Blog</a>
                            <span className="text-white mx-1">&middot;</span>
                            <a className="link-light small" href="/pricing">Pricing</a>
                            <span className="text-white mx-1">&middot;</span>
                            <a className="link-light small" href="/contact">Contact</a>
                            <span className="text-white mx-1">&middot;</span>
                            <a className="link-light small" href="/terms">Terms</a>
                            <span className="text-white mx-1">&middot;</span>
                            <a className="link-light small" href="/privacy">Privacy</a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}